import React, { useEffect, useState } from "react";
import { ControlLabel, FormControl, FormGroup, Modal } from "react-bootstrap";
import ScreenLoader from "views/Components/screenLoader";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { getAllMedicationCategory } from "api/purchaseOrder/PurchaseOrder";

const AddMedicationModal = (props) => {
  const token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const [medicationCategory, setMedicationCategory] = useState([]);

  useEffect(() => {
    getAllMedicationCategory(obj)
      .then((data) => {
        const categories = data.data.map((category) => ({
          value: category.id,
          label: category.category_name,
        }));
        setMedicationCategory(categories);
      })
      .catch((error) => {
        console.error("Error fetching medication categories:", error);
      });
  }, []);

  return (
    <div className="main-content">
      {props.isLoading && <ScreenLoader />}
      <Modal
        show={props.isOpen}
        onHide={props.isLoading ? () => {} : props.onClose}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Add Medication</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <ControlLabel htmlFor="po-medication-category">
              Medication Category
            </ControlLabel>
            <Select
              inputId="po-medication-category"
              isDisabled={props.isLoading}
              options={medicationCategory}
              value={props.selectedMedicationCategory}
              onChange={(selectedOption) => {
                props.setSelectedMedicationCategory(selectedOption);
                props.setMedicationModalCategoryError(null);
              }}
              placeholder="Select Medication Category"
            />
            {props.medicationModalCategoryError && (
              <div style={{ color: "red" }}>
                {props.medicationModalCategoryError}
              </div>
            )}
          </FormGroup>
          <FormGroup controlId="po-medication-name">
            <ControlLabel>Medication Name</ControlLabel>
            <FormControl
              type="text"
              disabled={props.isLoading}
              placeholder="Medication Name"
              value={props.medicationName}
              onChange={(e) => {
                props.setMedicationName(e.target.value);
                props.setMedicationModalNameError(null);
              }}
            />
            {props.medicationModalNameError && (
              <div style={{ color: "red" }}>
                {props.medicationModalNameError}
              </div>
            )}
          </FormGroup>
          {props.medicationDetails && (
            <>
              <FormGroup controlId="po-medication-unit-price">
                <ControlLabel>Buying Price (Per Item/Tablet)</ControlLabel>
                <FormControl
                  type="number"
                  min="0"
                  step="any"
                  name="unit_price"
                  placeholder="Buying Price (Per Item/Tablet)"
                  value={props.medicationDetails.unit_price}
                  disabled={props.isLoading}
                  aria-invalid={!!props.medicationDetailsErrors.unit_price}
                  onKeyDown={(event) => {
                    if (["-", "+", "e", "E"].includes(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onWheel={(event) => event.currentTarget.blur()}
                  aria-describedby={
                    props.medicationDetailsErrors.unit_price
                      ? "po-medication-unit-price-error"
                      : undefined
                  }
                  onChange={(event) => {
                    const value = event.target.value;
                    if (value === "" || Number(value) >= 0) {
                      props.onMedicationDetailChange("unit_price", value);
                    }
                  }}
                />
                {props.medicationDetailsErrors.unit_price && (
                  <small
                    id="po-medication-unit-price-error"
                    className="text-danger"
                  >
                    {props.medicationDetailsErrors.unit_price}
                  </small>
                )}
              </FormGroup>

              <FormGroup controlId="po-medication-selling-price">
                <ControlLabel>Selling Price (Per Item/Tablet)</ControlLabel>
                <FormControl
                  type="number"
                  min="0"
                  step="any"
                  name="price"
                  placeholder="Selling Price (Per Item/Tablet)"
                  value={props.medicationDetails.price}
                  disabled={props.isLoading}
                  aria-invalid={!!props.medicationDetailsErrors.price}
                  onKeyDown={(event) => {
                    if (["-", "+", "e", "E"].includes(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onWheel={(event) => event.currentTarget.blur()}
                  aria-describedby={
                    props.medicationDetailsErrors.price
                      ? "po-medication-selling-price-error"
                      : undefined
                  }
                  onChange={(event) => {
                    const value = event.target.value;
                    if (value === "" || Number(value) >= 0) {
                      props.onMedicationDetailChange("price", value);
                    }
                  }}
                />
                {props.medicationDetailsErrors.price && (
                  <small
                    id="po-medication-selling-price-error"
                    className="text-danger"
                  >
                    {props.medicationDetailsErrors.price}
                  </small>
                )}
              </FormGroup>

              <FormGroup controlId="po-medication-description">
                <ControlLabel>Description</ControlLabel>
                <FormControl
                  type="text"
                  name="description"
                  placeholder="Enter Description (optional)"
                  value={props.medicationDetails.description}
                  disabled={props.isLoading}
                  onChange={(event) =>
                    props.onMedicationDetailChange(
                      "description",
                      event.target.value,
                    )
                  }
                />
              </FormGroup>
            </>
          )}
          {props.medicationSubmitError && (
            <div className="alert alert-danger" role="alert">
              {props.medicationSubmitError}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={props.onClose}
            disabled={props.isLoading}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={props.handleAddMedication}
            disabled={props.isLoading}
            aria-busy={props.isLoading}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default AddMedicationModal;
